import { styled } from '@mui/material';
import { spacing } from '@mui/system';
import { FC } from 'react';
import { FormRowProps } from './model/FormRowProps';

type Props = FormRowProps & {
  focused?: boolean;
};

const StyledFormRow = styled('div')<Props>`
  ${spacing}
  ${({ theme, alignItems, display, focused, justifyContext }): string => `
    ${justifyContext ? `justify-content: ${justifyContext};` : ''};
    display: ${display ?? 'flex'};
    color: ${theme.palette.grey[500]};
    font-weight: 400;
    font-size: ${theme.typography?.fontSize}px;
    .MuiFormControlLabel-root {
      align-items: ${alignItems ?? 'center'};
    }
    .MuiCheckbox-root + * {
      padding-top: ${theme.spacing(0.5)};
    }
    border: 2px solid ${focused ? theme.palette.info.main : 'transparent'};
    border-radius: 4px;
  `}
`;

const StyledFormRowDivider = styled(StyledFormRow)`
  border-bottom: 1px solid
    ${({ theme: { palette } }): string => `${palette.grey[200]}
  `};
`;

export const FormRow: FC<Props> = ({ divider, children, ...props }) => {
  const FormRowComponent = divider ? StyledFormRowDivider : StyledFormRow;
  return (
    <FormRowComponent mb={3} {...props}>
      {children}
    </FormRowComponent>
  );
};
